import { Box, Typography, Avatar, Skeleton } from "@mui/material";
import Twillio from "src/assets/images/settings/twilio.svg";
import useStyles from "./Styles";

const TwilioSkeleton = () => {
  const { classes } = useStyles();
  return (
    <Box className={classes.container}>
      <Box className={classes.headerBox}>
        <Avatar src={Twillio} className={classes.avtarStyle} />
        <Box className={classes.textHead}>
          <Typography component="p" className={classes.headerHeading}>
            Checking Twilio configuration...
          </Typography>
          <Typography component="p" className={classes.headerSubHeading}>
            Please wait while we verify your Twilio account connection.
          </Typography>
        </Box>
      </Box>
      <Box>
        <Skeleton height={50} />
        <Skeleton height={50} style={{ marginTop: 8 }} />
      </Box>
    </Box>
  );
};

export default TwilioSkeleton;
